import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import supplierService from "../../services/supplierService";

export const fetchSupplier=createAsyncThunk(
    "supplier/fetch",
    async()=>{
        return await supplierService.getSupplier();
    }
);

export const removeSupplier=createAsyncThunk(
    "supplier/delete",
    async(id)=>{

        await supplierService.deleteSupplier(id);

        return id;

    }
);

export const addSupplier = createAsyncThunk(
    "supplier/add",
    async (formData, thunkAPI) => {
        try {
            return await supplierService.addSupplier(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const supplierSlice=createSlice({

    name:"supplier",

    initialState:{
        supplier:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchSupplier.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchSupplier.fulfilled,(state,action)=>{
    state.loading=false;
    state.supplier=action.payload;
})

.addCase(fetchSupplier.rejected,(state)=>{
    state.loading=false;
})

.addCase(addSupplier.fulfilled,(state,action)=>{

    state.supplier.unshift(action.payload);

})

.addCase(removeSupplier.fulfilled,(state,action)=>{

    state.supplier=
    state.supplier.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default supplierSlice.reducer;